import * as instrument from "../../../../assessments/instruments/sample/core-1-2-r1.js";
import { isCalendarDate, notAfterToday } from "../../checks.js";
import type { Decorator } from "../../decorator.js";
import { checkOf } from "../../decorators/checkOf.js";
import { controlOf } from "../../decorators/controlOf.js";
import { formOrder } from "../../decorators/formOrder.js";
import type { SupportedVersions } from "../../supportedVersions.js";

const { groups, items } = instrument;

/** The order the instrument module lists, which a stored schema does not keep. */
export const order: Decorator = formOrder(instrument, {
  groups: [groups.life_functioning, groups.trauma, groups.review],
  items: [
    items.school_attendance,
    items.school_engagement,
    items.family_history,
    items.adjustment_to_trauma,
    items.last_reviewed_on,
    items.key_worker,
    items.summary,
  ],
});

/**
 * The review date picked as a date, and held to a real day no later than
 * today: the instrument accepts any text, so a record from elsewhere saying
 * "March 2019" stays valid, and only our form insists on a day.
 */
export const reviewDate: readonly Decorator[] = [
  controlOf(instrument, items.last_reviewed_on, "date"),
  checkOf(instrument, items.last_reviewed_on, isCalendarDate),
  checkOf(instrument, items.last_reviewed_on, notAfterToday),
];

export const sampleCore_1_2: SupportedVersions = {
  versions: [["sample", "core", "1.2"]],
  decorators: [order, ...reviewDate],
};
